export default __webpack_public_path__ + "static/media/093-left-arrow-2.2b2bfd97.png";